/**
 * Bloomer Diamonds - Store-Wide Luxury Scroll & Fade Animation Engine
 * Comprehensive coverage across all pages • Zero Blink • Single Smooth Reveal
 */

(function () {
  'use strict';

  function autoTagElements() {
    // 1. Headings & Titles
    const headings = document.querySelectorAll(
      'h1:not([data-aos]):not(.visually-hidden), h2:not([data-aos]):not(.visually-hidden), h3:not([data-aos]):not(.visually-hidden), ' +
      '.banner__heading:not([data-aos]), .rich-text__heading:not([data-aos]), .image-with-text__heading:not([data-aos]), ' +
      '.section-heading:not([data-aos]), .collection__title:not([data-aos]), .product__title:not([data-aos]), .page-title:not([data-aos]), ' +
      '.diamond-header h1:not([data-aos]), .diamond-header p:not([data-aos]), .main-page-title:not([data-aos]), .article-template__title:not([data-aos]), ' +
      '.custom-featured-collection__title:not([data-aos]), .custom-brand-story__title:not([data-aos]), .shop-the-look__title:not([data-aos]), ' +
      '.custom-testimonials__title:not([data-aos]), .custom-faq__title:not([data-aos]), .custom-instagram__title:not([data-aos]), ' +
      '.custom-editorial-banner__title:not([data-aos]), .custom-shop-by-category__title:not([data-aos]), .custom-featured-product__title:not([data-aos]), .custom-luxury-box-title:not([data-aos])'
    );
    headings.forEach(function (el) {
      if (el.closest('#shopify-section-header') || el.closest('#shopify-section-announcement-bar') || el.closest('.cart-drawer')) return;
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-duration', '1000');
    });

    // 2. Subtitles & Captions & Toolbars
    const subtitles = document.querySelectorAll(
      '.banner__subheading:not([data-aos]), .subtitle:not([data-aos]), .caption:not([data-aos]), ' +
      '.rich-text__subheading:not([data-aos]), .collection-hero__description:not([data-aos]), ' +
      '.custom-featured-collection__view-all:not([data-aos]), .custom-editorial-banner__button:not([data-aos]), ' +
      '.custom-collection-toolbar:not([data-aos]), .diamond-search__results-bar:not([data-aos])'
    );
    subtitles.forEach(function (el) {
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-duration', '1000');
      el.setAttribute('data-aos-delay', '50');
    });

    // 3. Text & Paragraphs
    const textBlocks = document.querySelectorAll(
      '.rich-text__text:not([data-aos]), .banner__text:not([data-aos]), .image-with-text__text:not([data-aos]), ' +
      '.product__description:not([data-aos]), .rte p:not([data-aos]), .main-page-content p:not([data-aos]), ' +
      '.custom-brand-story__text:not([data-aos]), .custom-editorial-banner__text:not([data-aos]), .custom-luxury-box-text:not([data-aos]), ' +
      '.article-template__content p:not([data-aos])'
    );
    textBlocks.forEach(function (el) {
      if (el.closest('#shopify-section-header') || el.closest('.cart-drawer')) return;
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-duration', '1000');
      el.setAttribute('data-aos-delay', '80');
    });

    // 4. Media & Banner Images
    const mediaItems = document.querySelectorAll(
      '.image-banner__media:not([data-aos]), .banner__media:not([data-aos]), .image-with-text__media:not([data-aos]), ' +
      '.multicolumn-card__image-wrapper:not([data-aos]), .collage__item:not([data-aos]), .article-template__hero-container:not([data-aos]), ' +
      '.custom-editorial-banner__image-wrapper:not([data-aos]), .shop-the-look__image-wrapper:not([data-aos]), .custom-featured-product__gallery:not([data-aos])'
    );
    mediaItems.forEach(function (el) {
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-duration', '1000');
      el.setAttribute('data-aos-delay', '50');
    });

    // 5. Buttons & CTAs & Forms
    const buttons = document.querySelectorAll(
      '.banner__buttons:not([data-aos]), .rich-text__buttons:not([data-aos]), .newsletter-form:not([data-aos]), ' +
      '.contact-form:not([data-aos]), .product-form__buttons:not([data-aos]), .custom-featured-product__actions:not([data-aos]), ' +
      '.diamond-search__tabs-header:not([data-aos]), .diamond-search__filter-panel:not([data-aos])'
    );
    buttons.forEach(function (el) {
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-duration', '1000');
      el.setAttribute('data-aos-delay', '80');
    });

    // 6. Multicolumn & Sidebars
    const multicolumns = document.querySelectorAll('.multicolumn-list__item:not([data-aos]), .custom-collection-sidebar:not([data-aos])');
    multicolumns.forEach(function (el, index) {
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-duration', '1000');
      el.setAttribute('data-aos-delay', String((index % 3) * 80));
    });

    // 7. Product Cards, Diamonds & Grid Items
    const cards = document.querySelectorAll(
      '.custom-card-item:not([data-aos]), .product-grid .grid__item:not([data-aos]), ' +
      '.custom-featured-collection__grid > li:not([data-aos]), .custom-shop-by-category__card:not([data-aos]), ' +
      '.custom-instagram__item:not([data-aos]), .shop-the-look__card:not([data-aos]), .diamond-card:not([data-aos]), ' +
      '.article-card:not([data-aos]), .blog-articles__article:not([data-aos])'
    );
    cards.forEach(function (el, index) {
      if (el.closest('#shopify-section-header') || el.closest('.cart-drawer')) return;
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-duration', '1000');
      el.setAttribute('data-aos-delay', String((index % 4) * 60));
    });

    // 8. Product Details Page (PDP) & Featured Product
    const pdpMedia = document.querySelector('.product__media-wrapper:not([data-aos])');
    if (pdpMedia) {
      pdpMedia.setAttribute('data-aos', 'fade-right');
      pdpMedia.setAttribute('data-aos-duration', '1000');
    }
    const pdpInfo = document.querySelector('.product__info-wrapper:not([data-aos]), .custom-featured-product__info:not([data-aos])');
    if (pdpInfo) {
      pdpInfo.setAttribute('data-aos', 'fade-left');
      pdpInfo.setAttribute('data-aos-duration', '1000');
    }

    const accordions = document.querySelectorAll('.product__accordion:not([data-aos])');
    accordions.forEach(function (el, index) {
      el.setAttribute('data-aos', 'fade-up');
      el.setAttribute('data-aos-duration', '900');
      el.setAttribute('data-aos-delay', String(50 + index * 50));
    });
  }

  let io = null;

  function observeElements() {
    if (!('IntersectionObserver' in window)) {
      // Fallback for ancient browsers
      document.querySelectorAll('[data-aos]').forEach(function (el) {
        el.classList.add('aos-animate');
      });
      return;
    }

    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('aos-animate');
            io.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -20px 0px',
        threshold: 0.02
      });
    }

    const unobserved = document.querySelectorAll('[data-aos]:not(.aos-animate)');
    unobserved.forEach(function (el) {
      io.observe(el);
    });
  }

  function initAnimations() {
    autoTagElements();
    observeElements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }

  window.addEventListener('load', function () {
    autoTagElements();
    observeElements();
  });

  // Observe dynamic additions (Diamond Search results, AJAX filtering)
  let debounceTimer;
  const observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      autoTagElements();
      observeElements();
    }, 150);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Shopify Customizer hook
  document.addEventListener('shopify:section:load', function () {
    autoTagElements();
    observeElements();
  });
})();
